'use strict';

var GridToolbarConfigurationEventsDirective = function GridToolbarConfigurationEventsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-events.html'),
    controller: 'GridToolbarConfigurationEventsController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarConfigurationEventsDirective.$inject = [];
module.exports = GridToolbarConfigurationEventsDirective;